var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subjectBtn",class:[_vm.isActive ? 'selectedBtn' : ''],style:(_vm.getSubjectBtnStyle(_vm.isActive))},[_c('span',{style:(_vm.isActive ? `color: ${_vm.honorRollConfig.subjectTextActiveColor}` : `color: ${_vm.honorRollConfig.subjectTextNormalColor}`)},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }